module.exports = __webpack_public_path__ + "images/job/detail/detail_icon09-922b53b14618281bdd54e721a40a4243.png";